// extracted by mini-css-extract-plugin
export default {"container":"styles_container__-U4Ew","header":"styles_header__h+v+g","row":"styles_row__3JtwQ","center":"styles_center__LHn9F","ml10":"styles_ml10__52DLY"};